module.exports = __webpack_public_path__ + "static/media/icon_file_comple.a042f7a9.svg";